module.exports = __webpack_public_path__ + "static/media/githubLight.bafee7d2.png";